module.exports = __webpack_public_path__ + "img/tMGox.38ef41d1.png";